import React from "react";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { formatDateTime } from "../../globalFunctions/DateTimeDisplayCleaner";

export default function NewsCard({ item }) {
  function cleanText(html) {
    if (!html) return "";
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  }

  const excerpt = item.summary || cleanText(item.content || "");

  return (
    <a
      href={`/actualites/${item.slug}`}
      className="rounded-xl overflow-hidden bg-white border border-primary/5 shadow-lg 
        hover:shadow-xl transition-all hover:-translate-y-1 flex flex-col"
    >
      {/* IMAGE */}
      <div className="w-full h-48 bg-gray-100">
        <img
          src={item.image}
          alt={item.title}
          className="w-full h-full object-cover"
        />
      </div>

      {/* CONTENT */}
      <div className="p-5 flex flex-col flex-grow">
        <div className="text-xs text-gray-600 mb-2">
          {formatDateTime(item.date)}
        </div>

        <h3 className="font-bold text-lg text-[#3a3a3a] mb-2 line-clamp-2">
          {item.title}
        </h3>

        {/* Bloc texte avec hauteur fixe pour des cards identiques */}
        <p className="text-gray-500 line-clamp-3 min-h-[72px]">{excerpt}</p>

        {/* CTA */}
        <div className="mt-auto pt-3">
          <span
            className="inline-flex items-center gap-1 text-sm font-semibold text-[#3a3a3a]
            hover:underline underline-offset-2 decoration-2 cursor-pointer"
          >
            Consulter l’article
            <ArrowRightIcon className="h-4 w-4" />
          </span>
        </div>
      </div>
    </a>
  );
}
